/* Fator 5 — Bolhas subindo, como fundo (mesmo desenho e movimento da seção "Bolhas subindo" que a Aline mandou)
   <f5-bolhas> cria o próprio <canvas> e desenha bolhas de vidro subindo, que desviam do mouse/dedo.
   Aparece quando o produto tem o campo "Bolhas no fundo" (custom.bolhas) marcado no painel:
   - atrás da área do produto (sections/main-product.liquid): o canvas fica do tamanho da tela e acompanha a rolagem;
   - dentro do card (snippets/product-card.liquid), atrás do nome, do preço e da foto.
   Atributos: data-n (quantidade), data-tela (canvas do tamanho da tela: no celular, 60% da quantidade),
              data-escala (tamanho das bolhas; o card usa maior), data-velocidade, data-mouse (0 = não desvia),
              data-foto (seletor dentro do mesmo pai: um 2º quadro onde as MESMAS bolhas passam por trás da foto —
              a foto usa mix-blend-mode: darken, então o branco dela deixa ver as bolhas e o frasco fica na frente).
   Quando começam: só depois que a página carregou E a cliente tocou na tela, rolou, teclou ou mexeu o mouse. Antes disso
   não existe canvas nem desenho, então o carregamento (e o PageSpeed, que não rola a página) fica livre delas.
   Depois, cada área só monta o canvas quando chega perto da tela (as de abas escondidas esperam a aba abrir).
   Um laço só (requestAnimationFrame) para todas as bolhas da página; cada uma para fora da tela e com o app em
   segundo plano; no celular e no tablet, a 30 quadros por segundo. "Reduzir movimento" no aparelho: as bolhas andam a 30% da velocidade. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('f5-bolhas') || !window.ResizeObserver || !window.IntersectionObserver) return;

  // Desenho das bolhas: o mesmo da seção "Bolhas subindo" (7 tipos, cada um em 5 tamanhos prontos)
  function makeSprites() {
    var out = [], K = 0.8;
    var V = [
      { t: 0.2, b: 0.3, c: 0.85, sp: 0.13, rim: 0.3, ex: 1.0 },
      { t: 0.15, b: 0.22, c: 0.7, sp: 0.1, rim: 0.24, ex: 1.04 },
      { t: 0.24, b: 0.35, c: 0.95, sp: 0.15, rim: 0.34, ex: 0.97 },
      { t: 0.17, b: 0.26, c: 0.6, sp: 0.09, rim: 0.22, ex: 1.06 },
      { t: 0.22, b: 0.32, c: 0.8, sp: 0.12, rim: 0.3, ex: 0.95 },
      { t: 0.13, b: 0.2, c: 0.75, sp: 0.11, rim: 0.2, ex: 1.02 }
    ];
    V.forEach(function (v) {
      var S = 160, c = S / 2, R = c * K, s = document.createElement('canvas'); s.width = s.height = S;
      var g = s.getContext('2d');
      var shape = function () { g.beginPath(); g.ellipse(c, c, R * v.ex, R / v.ex, 0, 0, 6.2832); };
      g.save(); g.shadowColor = 'rgba(0,10,10,0.12)'; g.shadowBlur = R * 0.22; g.shadowOffsetY = R * 0.1;
      shape(); g.fillStyle = 'rgba(0,0,0,0.01)'; g.fill(); g.restore();
      g.save(); shape(); g.clip();
      var lg = g.createLinearGradient(0, c - R, 0, c + R);
      lg.addColorStop(0, 'rgba(8,16,16,' + v.t + ')'); lg.addColorStop(0.5, 'rgba(8,16,16,' + v.t * 0.35 + ')');
      lg.addColorStop(0.8, 'rgba(235,245,242,' + v.b * 0.6 + ')'); lg.addColorStop(1, 'rgba(255,255,255,' + v.b + ')');
      g.fillStyle = lg; g.fillRect(0, 0, S, S);
      var r = g.createRadialGradient(c, c, R * 0.55, c, c, R * 1.02);
      r.addColorStop(0, 'rgba(6,12,12,0)'); r.addColorStop(0.8, 'rgba(6,12,12,' + v.rim * 0.45 + ')'); r.addColorStop(1, 'rgba(6,12,12,' + v.rim + ')');
      g.fillStyle = r; g.fillRect(0, 0, S, S);
      g.save(); g.shadowColor = 'rgba(255,255,255,' + v.c + ')'; g.shadowBlur = R * 0.18;
      g.strokeStyle = 'rgba(255,255,255,' + v.c + ')'; g.lineWidth = R * 0.14; g.lineCap = 'round';
      g.beginPath(); g.ellipse(c, c + R * 0.04, R * 0.74 * v.ex, R * 0.74 / v.ex, 0, 0.55, 2.6); g.stroke(); g.restore();
      g.save(); g.translate(c - R * 0.34, c - R * 0.44); g.rotate(-0.6);
      g.fillStyle = 'rgba(255,255,255,0.97)'; g.beginPath(); g.ellipse(0, 0, R * v.sp * 1.5, R * v.sp * 0.85, 0, 0, 6.2832); g.fill();
      g.fillStyle = 'rgba(255,255,255,0.55)'; g.beginPath(); g.arc(R * 0.26, R * 0.05, R * v.sp * 0.4, 0, 6.2832); g.fill();
      g.restore();
      g.restore();
      g.globalCompositeOperation = 'destination-in';
      var fm = g.createRadialGradient(c, c, 0, c, c, R * 1.3);
      fm.addColorStop(0, 'rgba(0,0,0,1)'); fm.addColorStop(0.7, 'rgba(0,0,0,1)'); fm.addColorStop(0.79, 'rgba(0,0,0,0.55)'); fm.addColorStop(1, 'rgba(0,0,0,0)');
      g.fillStyle = fm; g.fillRect(0, 0, S, S);
      out.push(s);
    });
    var S = 40, c = S / 2, R = c * K, m = document.createElement('canvas'); m.width = m.height = S; var g = m.getContext('2d');
    g.save(); g.beginPath(); g.arc(c, c, R, 0, 6.2832); g.clip();
    var lg = g.createLinearGradient(0, c - R, 0, c + R);
    lg.addColorStop(0, 'rgba(8,16,16,0.32)'); lg.addColorStop(0.55, 'rgba(8,16,16,0.12)'); lg.addColorStop(1, 'rgba(255,255,255,0.7)');
    g.fillStyle = lg; g.fillRect(0, 0, S, S);
    g.fillStyle = 'rgba(255,255,255,0.95)'; g.beginPath(); g.arc(c - R * 0.3, c - R * 0.35, R * 0.22, 0, 6.2832); g.fill();
    g.restore();
    g.globalCompositeOperation = 'destination-in';
    var fm = g.createRadialGradient(c, c, 0, c, c, R * 1.25);
    fm.addColorStop(0, 'rgba(0,0,0,1)'); fm.addColorStop(0.7, 'rgba(0,0,0,1)'); fm.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = fm; g.fillRect(0, 0, S, S);
    out.push(m);
    return out.map(function (src) {
      return [8, 16, 32, 64, 128].map(function (sz) {
        var k = document.createElement('canvas'); k.width = k.height = sz; var kg = k.getContext('2d');
        kg.imageSmoothingEnabled = true; kg.imageSmoothingQuality = 'high'; kg.drawImage(src, 0, 0, sz, sz); return k;
      });
    });
  }

  var sprites = null;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Laço único: anda e desenha só as bolhas que estão na tela
  var ativos = [];
  var raf = 0;
  var pausa = 0;
  var last = 0;
  function pede() {
    if (raf || pausa || document.hidden) { return; }
    last = performance.now();
    raf = requestAnimationFrame(loop);
  }
  function loop(now) {
    raf = 0;
    // Celular: nunca desenha antes do 2º quadro de tela depois do último desenho (ver proximo())
    if (celular() && now - last < 28) { raf = requestAnimationFrame(loop); return; }
    var dt = Math.min(0.05, (now - last) / 1000);
    last = now;
    if (reduce) { dt *= 0.3; }
    var algum = false;
    for (var i = 0; i < ativos.length; i++) {
      if (ativos[i].visivel && ativos[i].W) { ativos[i].frame(dt); algum = true; }
    }
    if (algum && !document.hidden) { proximo(); }
  }
  // No celular e no tablet, 30 quadros por segundo. Cada quadro obriga o navegador a refazer estilo, pintura e camadas
  // da página inteira (inclusive o brilho dos selos dos cards), e isso custa mais que as bolhas em si: por isso não pede
  // o requestAnimationFrame a cada quadro de tela. Desenhar direto num timer de 33 ms saía fora do compasso da tela
  // (o desenho caía ora no 2º, ora no 3º quadro, e as bolhas andavam aos trancos). Então: um timer até 19 ms depois do
  // último desenho e aí o rAF, que desenha no 2º quadro de tela. Se o Chrome entregar o rAF no quadro que já passou,
  // o loop() pula esse e desenha no seguinte.
  var toque = window.matchMedia && matchMedia('(pointer: coarse)').matches;
  function celular() { return toque || window.innerWidth < 700; }
  function proximo() {
    if (celular()) {
      pausa = setTimeout(function () { pausa = 0; raf = requestAnimationFrame(loop); }, Math.max(0, 19 - (performance.now() - last)));
    } else {
      raf = requestAnimationFrame(loop);
    }
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { pede(); } });

  // Partida: página carregada + 1º gesto de verdade da cliente. Até lá os elementos só ficam na lista de espera.
  // Não usa o evento "scroll": os carrosséis que andam sozinhos também rolam, e ligariam as bolhas sem ninguém mexer.
  // A rolagem no celular começa com o dedo (touchstart); no computador, com a roda do mouse (wheel) ou o teclado.
  var liberado = false;
  var interagiu = false;
  var carregou = document.readyState === 'complete';
  var esperando = [];
  var GESTOS = ['touchstart', 'pointerdown', 'pointermove', 'wheel', 'keydown'];
  // Monta cada área quando ela chega a 200 px da tela
  var fila = [];
  var perto = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) { return; }
      perto.unobserve(e.target);
      fila.push(e.target);
    });
    if (fila.length) { monta(); }
  }, { rootMargin: '200px 0px' });
  // Uma área por tarefa, para nenhuma tarefa ficar longa
  function monta() {
    var el = fila.shift();
    if (el && el.isConnected) { el.iniciar(); }
    if (fila.length) { setTimeout(monta, 0); }
  }
  function libera() {
    if (liberado || !interagiu || !carregou) { return; }
    liberado = true;
    var vai = function () { esperando.forEach(function (el) { perto.observe(el); }); esperando = []; };
    if (window.requestIdleCallback) { requestIdleCallback(vai, { timeout: 500 }); } else { setTimeout(vai, 50); }
  }
  function aoGesto(e) {
    if (!e.isTrusted) { return; }
    interagiu = true;
    GESTOS.forEach(function (t) { window.removeEventListener(t, aoGesto, true); });
    // 400 ms: o 1º toque costuma ser num botão; a resposta dele (clique e pintura) passa na frente das bolhas
    setTimeout(libera, 400);
  }
  GESTOS.forEach(function (t) { window.addEventListener(t, aoGesto, { capture: true, passive: true }); });
  if (!carregou) {
    window.addEventListener('load', function () {
      carregou = true;
      // a cliente já rolou antes deste script existir (celular lento): conta como gesto
      if (window.scrollY > 0) { aoGesto({ isTrusted: true }); return; }
      libera();
    }, { once: true });
  }
  // No editor de temas não há cliente nem PageSpeed: as bolhas aparecem sem esperar gesto
  if (window.Shopify && Shopify.designMode) { aoGesto({ isTrusted: true }); }

  function F5Bolhas() { return Reflect.construct(HTMLElement, [], F5Bolhas); }
  F5Bolhas.prototype = Object.create(HTMLElement.prototype);
  F5Bolhas.prototype.constructor = F5Bolhas;
  Object.setPrototypeOf(F5Bolhas, HTMLElement);

  F5Bolhas.prototype.connectedCallback = function () {
    if (this.ligado) { return; }
    if (liberado) { perto.observe(this); } else if (esperando.indexOf(this) === -1) { esperando.push(this); }
  };

  F5Bolhas.prototype.iniciar = function () {
    if (this.ligado) { return; }
    this.ligado = true;
    var self = this;
    sprites = sprites || makeSprites();
    this.n = parseInt(this.getAttribute('data-n') || '60', 10);
    this.vel = parseFloat(this.getAttribute('data-velocidade') || '1');
    this.forca = parseFloat(this.getAttribute('data-mouse') || '1');
    this.escala = parseFloat(this.getAttribute('data-escala') || '1');
    this.tela = this.hasAttribute('data-tela');
    this.B = [];
    this.t = 0;
    this.W = 0; this.H = 0; this.dpr = 1;
    this.mouse = { x: -9999, y: -9999, on: false };
    this.visivel = false;

    this.cv = document.createElement('canvas');
    this.appendChild(this.cv);
    this.ctx = this.cv.getContext('2d');
    var sel = this.getAttribute('data-foto');
    var quadro = sel && this.parentElement && this.parentElement.querySelector(sel);
    if (quadro) {
      this.fcv = document.createElement('canvas');
      this.fcv.className = 'f5-bolhas-foto';
      this.fcv.setAttribute('aria-hidden', 'true');
      quadro.insertBefore(this.fcv, quadro.firstChild);
      this.fctx = this.fcv.getContext('2d');
    }

    this.ro = new ResizeObserver(function () { self.resize(); });
    this.ro.observe(this.cv);
    if (this.fcv) { this.ro.observe(this.fcv); }
    this.io = new IntersectionObserver(function (e) {
      self.visivel = e[e.length - 1].isIntersecting;
      if (self.visivel) { pede(); }
    });
    this.io.observe(this);

    // O mouse/dedo vale na área toda (o canvas fica atrás do conteúdo e não recebe os toques)
    this.alvo = this.parentElement;
    this.onMove = function (e) { self.mouse.cx = e.clientX; self.mouse.cy = e.clientY; self.mouse.on = true; };
    this.onLeave = function () { self.mouse.on = false; };
    this.onUp = function (e) { if (e.pointerType !== 'mouse') { self.mouse.on = false; } };
    if (this.alvo && this.forca > 0) {
      this.alvo.addEventListener('pointermove', this.onMove, { passive: true });
      this.alvo.addEventListener('pointerdown', this.onMove, { passive: true });
      this.alvo.addEventListener('pointerleave', this.onLeave, { passive: true });
      this.alvo.addEventListener('pointerup', this.onUp, { passive: true });
      this.alvo.addEventListener('pointercancel', this.onLeave, { passive: true });
    }

    ativos.push(this);
  };

  F5Bolhas.prototype.disconnectedCallback = function () {
    if (!this.ligado) {
      var j = esperando.indexOf(this);
      if (j !== -1) { esperando.splice(j, 1); }
      perto.unobserve(this);
      return;
    }
    this.ligado = false;
    var i = ativos.indexOf(this);
    if (i !== -1) { ativos.splice(i, 1); }
    this.ro.disconnect();
    this.io.disconnect();
    if (this.alvo) {
      this.alvo.removeEventListener('pointermove', this.onMove);
      this.alvo.removeEventListener('pointerdown', this.onMove);
      this.alvo.removeEventListener('pointerleave', this.onLeave);
      this.alvo.removeEventListener('pointerup', this.onUp);
      this.alvo.removeEventListener('pointercancel', this.onLeave);
    }
    if (this.cv && this.cv.parentNode) { this.cv.parentNode.removeChild(this.cv); }
    if (this.fcv && this.fcv.parentNode) { this.fcv.parentNode.removeChild(this.fcv); }
  };

  F5Bolhas.prototype.spawn = function (b, initial) {
    var W = this.W, H = this.H;
    var q = Math.random();
    var r0 = q < 0.5 ? 0.8 + Math.random() * 1.2 : q < 0.85 ? 2 + Math.random() * 3 : 5 + Math.pow(Math.random(), 1.5) * 10;
    b.r = r0 * this.escala;
    b.spr = r0 < 1.7 ? 6 : Math.floor(Math.random() * 6);   // as menores usam o desenho simples
    b.x0 = Math.random();
    b.y = initial ? Math.random() * H : H + b.r * 3 + Math.random() * H * 0.15;
    b.v = (18 + b.r * 5 + Math.random() * 20) * this.vel;
    b.wf = 0.3 + Math.random() * 0.8; b.wa = 3 + Math.random() * 14; b.ph = Math.random() * 6.283;
    b.al = 0.55 + Math.random() * 0.45; b.sq = 1 + (Math.random() - 0.5) * 0.12;
    b.ox = 0; b.oy = 0; b.vx = 0; b.vy = 0;
    return b;
  };

  // Trocar width/height apaga e realoca o canvas: só quando o tamanho mudou de verdade
  function tamanho(cv, r, dpr) {
    var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
    if (cv.width !== w) { cv.width = w; }
    if (cv.height !== h) { cv.height = h; }
  }

  F5Bolhas.prototype.resize = function () {
    var r = this.cv.getBoundingClientRect();
    this.dpr = Math.min(2, window.devicePixelRatio || 1);
    this.W = r.width; this.H = r.height;
    tamanho(this.cv, r, this.dpr);
    if (this.fcv) {
      // posição do quadro da foto dentro da área (fica igual na rolagem: os dois andam juntos)
      var f = this.fcv.getBoundingClientRect();
      this.fx = f.left - r.left; this.fy = f.top - r.top;
      tamanho(this.fcv, f, this.dpr);
    }
    var n = this.W ? Math.round(this.n * (this.tela && this.W < 700 ? 0.6 : 1)) : 0;
    while (this.B.length < n) { this.B.push(this.spawn({}, true)); }
    this.B.length = n;
    if (this.W) { pede(); }
  };

  // Um quadro: move as bolhas e desenha no canvas da área (e no da foto, deslocado, com as mesmas bolhas)
  F5Bolhas.prototype.frame = function (dt) {
    var W = this.W, H = this.H, dpr = this.dpr, ctx = this.ctx, fctx = this.fctx;
    this.t += dt;
    var t = this.t;
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, this.cv.width, this.cv.height);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    if (fctx) {
      fctx.setTransform(1, 0, 0, 1, 0, 0); fctx.clearRect(0, 0, this.fcv.width, this.fcv.height);
      fctx.setTransform(dpr, 0, 0, dpr, -this.fx * dpr, -this.fy * dpr);
    }
    var mouse = this.mouse, MOUSE = this.forca;
    if (mouse.on) { var cr = this.cv.getBoundingClientRect(); mouse.x = mouse.cx - cr.left; mouse.y = mouse.cy - cr.top; }
    var MR = Math.max(70, Math.min(W, H) * 0.14), MR2 = MR * MR, st = Math.min(3, dt * 60), k = 0.035 * st, damp = Math.pow(0.88, st);
    for (var i = 0; i < this.B.length; i++) {
      var b = this.B[i];
      b.y -= b.v * dt;
      if (b.y < -b.r * 4) { this.spawn(b, false); }
      var x = b.x0 * W + Math.sin(t * b.wf + b.ph) * b.wa, y = b.y;
      if (mouse.on && MOUSE > 0) {
        var dx = x + b.ox - mouse.x, dy = y + b.oy - mouse.y, d2 = dx * dx + dy * dy;
        if (d2 < MR2 && d2 > 0.01) { var dd = Math.sqrt(d2), s = 1 - dd / MR, fz = s * s * MOUSE * 1.5 * st; b.vx += dx / dd * fz; b.vy += dy / dd * fz; }
      }
      b.vx = (b.vx - b.ox * k) * damp; b.vy = (b.vy - b.oy * k) * damp; b.ox += b.vx * st; b.oy += b.vy * st;
      var fadeIn = Math.min(1, (H + b.r * 3 - y) / (H * 0.12));
      var al = b.al * Math.max(0, fadeIn);
      if (al < 0.01) { continue; }
      var sq = b.sq + 0.03 * Math.sin(t * 1.1 + b.ph * 2), w = 2.5 * b.r * sq, h = 2.5 * b.r / sq, px = x + b.ox, py = y + b.oy;
      var need = w * dpr, lv = sprites[b.spr], img = need <= 8 ? lv[0] : need <= 16 ? lv[1] : need <= 32 ? lv[2] : need <= 64 ? lv[3] : lv[4];
      ctx.globalAlpha = al;
      ctx.drawImage(img, px - w / 2, py - h / 2, w, h);
      if (fctx) { fctx.globalAlpha = al; fctx.drawImage(img, px - w / 2, py - h / 2, w, h); }
    }
    ctx.globalAlpha = 1;
    if (fctx) { fctx.globalAlpha = 1; }
  };

  customElements.define('f5-bolhas', F5Bolhas);
})();
